export enum actionTypes {
  // nav action types
  SET_ACTIVE_PATH = 'SET_ACTIVE_PATH',
  SELECT_EDITOR_TAB = 'SELECT_EDITOR_TAB',
  SELECT_CUSTOMIZATION_CATEGORY = 'SELECT_CUSTOMIZATION_CATEGORY',
  SET_CUSTOMIZATION_SEARCH = 'SET_CUSTOMIZATION_SEARCH',
  NAVIGATE_TO_ENTRY = 'NAVIGATE_TO_ENTRY',

  // webchat styling action types
  UPDATE_STYLE_OPTIONS ='UPDATE_STYLE_OPTIONS',
  UPDATE_STYLE_ELEMENT = 'UPDATE_STYLE_ELEMENT',
  UPDATE_ROOT_WEBCHAT_STATE_VARIABlE = 'UPDATE_ROOT_WEBCHAT_STATE_VARIABlE',
  
  // creation Experience action types
  UPDATE_ROOT_CREATION_STATE_VARIABlE = 'UPDATE_ROOT_CREATION_STATE_VARIABlE',

  // open close modal
  UPDATE_MODAL_OPTIONS= 'UPDATE_MODAL_OPTIONS',
}

export function genericSingleAction<T>(actionName: actionTypes, property?: T): GenericAction<actionTypes, T> {
  return {
    type: actionName,
    payload: property
  };
}

export class GenericAction<ActionType, PayloadType> {

  constructor(type: ActionType, payload?: PayloadType) {
    this.type = type;
    this.payload = payload;
  }

  type: ActionType;
  payload?: PayloadType;
}